const TRUST_ITEMS = [
  {
    value: '10+',
    unit: 'лет',
    desc: 'Работаем с металлом. Знаем все тонкости сварки, покраски и&nbsp;монтажа.',
    icon: 'ri-building-2-line',
  },
  {
    value: '500+',
    unit: 'объектов',
    desc: 'Построили по всему району — от&nbsp;Приютово до&nbsp;Уфы, от&nbsp;Бугуруслана до&nbsp;Бавлов.',
    icon: 'ri-check-double-line',
  },
  {
    value: '100%',
    unit: 'гарантия',
    desc: 'На каркас и монтаж. Если что-то не&nbsp;так — приедем и&nbsp;исправим.',
    icon: 'ri-shield-check-line',
  },
  {
    value: '1',
    unit: 'день',
    desc: 'На расчёт сметы после замера. Не&nbsp;тянем, называем цену сразу.',
    icon: 'ri-time-line',
  },
];

export default function TrustNumbers() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="trust">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Почему нам доверяют
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Цифры говорят сами за себя
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {TRUST_ITEMS.map((item) => (
            <div
              key={item.desc}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-7 text-center group hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-1">
                {item.value}
              </div>
              <div className="text-sm text-foreground-500 font-medium mb-3">
                {item.unit}
              </div>
              <p
                className="text-sm text-foreground-600 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              ></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}